// test2252
(2252 && 0);
